import type {
  AuthResponse,
  ChangePasswordData,
  LoginCredentials,
  RegisterData,
  User,
} from '@/types';
import api from './api';

export const authService = {
  async login(credentials: LoginCredentials): Promise<AuthResponse> {
    const response = await api.post<AuthResponse>('/auth/login', credentials);
    return response.data;
  },

  async register(data: RegisterData): Promise<{ message: string; user: Partial<User> }> {
    const response = await api.post('/auth/register', data);
    return response.data;
  },

  async logout(): Promise<void> {
    await api.post('/auth/logout');
    localStorage.removeItem('accessToken');
  },

  async refreshToken(): Promise<{ accessToken: string }> {
    const response = await api.post('/auth/refresh');
    return response.data;
  },

  async changePassword(data: ChangePasswordData): Promise<{ success: boolean; message: string }> {
    const response = await api.post('/auth/change-password', data);
    return response.data;
  },

  async checkPasswordReset(): Promise<{ passwordResetRequired: boolean }> {
    const response = await api.get('/auth/check-password-reset');
    return response.data;
  },

  async getCurrentUser(): Promise<User> {
    const response = await api.get('/auth/me');
    return response.data;
  },
};

export default authService;
